import React from 'react';
import { WHATSAPP_URL } from '../../content/siteContent';
import { WhatsAppIcon } from './Icons';

export default function FloatingWhatsApp() {
  return (
    <a
      id="Whatsapp"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="floating-whatsapp"
      aria-label="Fale conosco no WhatsApp"
    >
      <span className="floating-tooltip">Fale com um Especialista</span>
      <WhatsAppIcon size={30} />
    </a>
  );
}
